module.exports = __webpack_public_path__ + "img/DP014_002.183f625b.png";